import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  DocumentNode,
  DefaultOptions,
  OperationVariables,
} from '@apollo/client/core';
import store from '../store/index';
import { checkIsAccessTokenExpired } from '../router/authGuard';

const baseURL = import.meta.env.VITE_GRAPHQL_BASE_URL;

const httpLink = createHttpLink({
  uri: baseURL,
});

const cache = new InMemoryCache();
const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

export const gqlClient = new ApolloClient({
  link: httpLink,
  cache,
  defaultOptions,
});

export async function makeRequest(
  type: 'query' | 'mutation',
  query: DocumentNode,
  variables: OperationVariables | undefined,
  context: any
): Promise<any> {
  try {
    await checkIsAccessTokenExpired();

    // Use token from context if provided, otherwise get from store
    const token = context?.token || store.getters['users/getToken'];

    const headers = {
      ...context?.headers,
      authorization: token ? `Bearer ${token}` : "",
    };

    let response;
    if (type === 'query') {
      response = await gqlClient.query({
        query,
        variables,
        context: { ...context, headers }
      });
    } else if (type === 'mutation') {
      response = await gqlClient.mutate({
        mutation: query,
        variables,
        context: { ...context, headers }
      });
    } else {
      throw new Error(`Invalid request type: ${type}`);
    }

    return response;
  } catch (error) {
    console.error('GraphQL request error:', error);
    throw error;
  }
}
